import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/h5_qrcode.png'
import _imports_1 from '@/assets/images/wechat_qrcode.png'


const _hoisted_1 = { class: "sideBar" }
const _hoisted_2 = { class: "sideBar-item" }
const _hoisted_3 = { class: "sideBar-item-qrcode" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  alt: "客服二维码"
}

import { useUserStore } from "@/store";


export default /*@__PURE__*/_defineComponent({
  __name: 'SideBar',
  setup(__props) {

const UserStore = useUserStore();
const openWindow = (link: string) => {
  window.open(link, "_blank");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"sideBar-item\" data-v-5edd8092><div class=\"sideBar-item-icon mobile\" data-v-5edd8092></div><div class=\"sideBar-item-text\" data-v-5edd8092>手机改卷</div><div class=\"sideBar-item-qrcode\" data-v-5edd8092><img src=\"" + _imports_0 + "\" alt=\"手机改卷二维码\" data-v-5edd8092></div></div>", 1)),
    _createElementVNode("div", {
      class: "sideBar-item",
      title: "点击下载扫描客户端",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (
        openWindow(
          'https://21-yuejuan-api.tos-cn-beijing.volces.com/scan/二一阅卷扫描_安装包.exe'
        )
      ))
    }, _cache[2] || (_cache[2] = [
      _createElementVNode("div", { class: "sideBar-item-icon printer" }, null, -1),
      _createElementVNode("div", { class: "sideBar-item-text" }, [
        _createTextVNode("扫描"),
        _createElementVNode("br"),
        _createTextVNode("客户端")
      ], -1)
    ])),
    _createElementVNode("div", {
      class: "sideBar-item",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (openWindow('https://yj.21cnjy.com/help/list2')))
    }, _cache[3] || (_cache[3] = [
      _createElementVNode("div", { class: "sideBar-item-icon help" }, null, -1),
      _createElementVNode("div", { class: "sideBar-item-text" }, "帮助中心", -1)
    ])),
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "sideBar-item-icon customerService" }, null, -1)),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "sideBar-item-text" }, "联系客服", -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("div", null, "电话：13684937620", -1)),
        _cache[5] || (_cache[5] = _createElementVNode("div", null, "微信扫码咨询客服", -1)),
        (_unref(UserStore).userInfo.qrCode)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _unref(UserStore).userInfo.qrCode,
              alt: "客服二维码"
            }, null, 8, _hoisted_4))
          : (_openBlock(), _createElementBlock("img", _hoisted_5))
      ])
    ])
  ]))
}
}

})